import layout from '@/layout/index.vue'
// 由于Nav引用，子路由路径必须写全路径
// children第一个是父菜单
export default [
  {
    path: '/',
    component: layout,
    meta: {nameCN: '首页', hasSubmenu: false},
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue')
      }
    ]
  },
  {
    path: '/products',
    component: layout,
    meta: {nameCN: '产品中心', hasSubmenu: true},
    children: [
      {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/Products/index.vue'),
      },
      {
        path: '/products#normaeweb',
        name: 'normaeweb',
        meta: { nameCN: '矩尺Web智能网关', isSubmenu: true },
        component: () => import('@/views/Products/index.vue'),
      },
      {
        path: '/products#normaeapp',
        name: 'normaeapp',
        meta: { nameCN: '矩尺应用交付平台', isSubmenu: true },
        component: () => import('@/views/Products/index.vue'),
      },
      {
        path: '/products#normaecloud',
        name: 'normaecloud',
        meta: { nameCN: '矩尺云原生流量引擎', isSubmenu: true },
        component: () => import('@/views/Products/index.vue'),
      },
      {
        path: '/products#normaeai',
        name: 'normaeai',
        meta: { nameCN: '矩尺AI网关', isSubmenu: true },
        component: () => import('@/views/Products/index.vue'),
      },
      {
        path: '/products#normaeunified',
        name: 'normaeunified',
        meta: { nameCN: '矩尺统一纳管平台', isSubmenu: true },
        component: () => import('@/views/Products/index.vue'),
      },
    ]
  },
  {
    path: '/case',
    component: layout,
    meta: {nameCN: '应用场景', hasSubmenu: true},
    children: [
      {
        path: '/case',
        name: 'Case',
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#casestatic',
        name: 'casestatic',
        meta: { nameCN: '静态资源托管与发布', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#caseaitraffic',
        name: 'caseaitraffic',
        meta: { nameCN: '基于AI应用的多模型流量治理', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#caseapi',
        name: 'caseapi',
        meta: { nameCN: 'API应用网关', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#caseglb',
        name: 'caseglb',
        meta: { nameCN: '全局负载均衡', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#casecloud',
        name: 'casecloud',
        meta: { nameCN: '多维流量治理与云原生架构演进', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#caseunified',
        name: 'caseunified',
        meta: { nameCN: '第三方负载均衡纳管', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
      {
        path: '/case#casesafe',
        name: 'casesafe',
        meta: { nameCN: '安全协作', isSubmenu: true },
        component: () => import('@/views/Case/index.vue'),
      },
    ]
  },
  {
    path: '/trial',
    component: layout,
    meta: {nameCN: '试用中心', hasSubmenu: false},
    children: [
      {
        path: '/trial',
        name: 'Free',
        component: () => import('@/views/Free/index.vue'),
      }
    ]
  },
  // {
  //   path: '/solution',
  //   component: layout,
  //   meta: {nameCN: '解决方案', hasSubmenu: false},
  //   children: [
  //     {
  //       path: '/solution',
  //       name: 'Solution',
  //       component: () => import('@/views/Solution/index.vue'),
  //     }
  //   ]
  // },
  // {
  //   path: '/service',
  //   component: layout,
  //   meta: {nameCN: '服务体系', hasSubmenu: false},
  //   children: [
  //     {
  //       path: '/service',
  //       name: 'Service',
  //       component: () => import('@/views/Service/index.vue'),
  //     }
  //   ]
  // },
  {
    path: '/about',
    component: layout,
    meta: {nameCN: '关于我们', hasSubmenu: false},
    children: [
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
      }
    ]
  }
]